import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import Game from '../scenes/Game';
import gameData from '../gameData';
import IntroAnt from './IntroAnt';

/** @type {GameBackground} */
let instance = null;

export default class GameBackground extends Phaser.Scene {
  static get KEY() { return 'GameBackground'; }

  static get instance() { return instance; }

  constructor() {
    super({ key: GameBackground.KEY });
    instance = this;
  }

  init() {
    this.finalFlag = null;

    this.scene.launch(gameData.firstScene);
  }

  create() {
    /** @type {Phaser.GameObjects.Image[]} */
    this.clouds = [];
    this.isCloudy = false;
    this.curWidth = this.scale.width;
    this.curHeight = this.scale.height;

    /** @type {Phaser.GameObjects.Image} */
    this.bgLayer = null;

    this.bgAudio = ABCyaPhaser.Audio.createSound(this, 1, true, 0, gameData.gameModeSoundAtlas);
  }

  switchBg (bgName,cloudy) {
    this.isCloudy = cloudy;
    if (!this.isCloudy) {
      while (this.clouds.length > 0) {
        this.clouds.shift().destroy();
      }
    }
    if (this.bgLayer !== null) {
      this.bgLayer.destroy();
      this.bgLayer = null;
    }
    this.bgLayer = ABCyaPhaser.Images.addImage(0,0,`${bgName}-bg`, this).setOrigin(0);
    this.children.sendToBack(this.bgLayer);

    if (bgName === 'title') {
      if (gameData.gameConfigs[gameData.game].GAME_TITLE === 'Take a Trip' && !this.car) {
        this.car = ABCyaPhaser.Images.addImage(0, 0, `title-car-${gameData.playerId}`, this).setOrigin(0);
        this.car.x = 30;
        this.car.y = this.scale.height - this.car.getBounds().height - 100;
      }
      else if (gameData.gameConfigs[gameData.game].GAME_TITLE === 'Food Groups' && !this.ant) {
        ABCyaPhaser.Audio.playSound('intro_loop', this.bgAudio, 1, true);

        this.ant = new IntroAnt(this);
        gameData.playerId = 'ant';
        this.add.existing(this.ant);

        this.ant.swayBounce();
        this.ant.x = 260;
        this.ant.y = this.scale.height - 50;
      }

      this.car?.setVisible(true);
      this.ant?.setVisible(true);
    }
    else {
      this.car?.setVisible(false);
      this.ant?.setVisible(false);

      this.bgAudio.stop();
    }
  }

  updateCarColor() {
    this.car?.setFrame(`title-car-${gameData.playerId}`);
  }

  addNewCloud () {
    const cloud = ABCyaPhaser.Images.addImage(0,0,'cloud', this);
    cloud.alpha = Phaser.Math.Between(7,10) / 10;
    cloud.x = this.clouds.length < 3 ? Phaser.Math.Between(0,this.curWidth) : (cloud.width + 20) * -1;
    cloud.y = Phaser.Math.Between(-50, 480);
    cloud.scale = Phaser.Math.Between(60,100) / 100;
    cloud._velX = Phaser.Math.Between(30,50) / 100;
    this.children.moveTo(cloud,1);
    this.clouds.push(cloud);
  }

  update() {
    if (this.clouds.length > 0) {
      for (let i = 0; i < this.clouds.length; i++) {
        const cloud = this.clouds[i];
        cloud.x += cloud._velX;
        if (cloud.x > this.scale.width + 150) {
          cloud.destroy();
          this.clouds.splice(i,1);
          i--;
        }
      }
    }

    if (this.clouds.length < 4 && this.isCloudy) {
      this.addNewCloud();
    }

    this.ant?.tick();
  }
}